import type { Theme } from '@taskos/shared';
import { writeLocal } from './storage';

const mq = typeof window !== 'undefined' ? window.matchMedia('(prefers-color-scheme: dark)') : null;
let current: Theme = 'SYSTEM';

function paint() {
  const dark = current === 'DARK' || (current === 'SYSTEM' && !!mq?.matches);
  document.documentElement.dataset.theme = dark ? 'dark' : 'light';
  const meta = document.querySelector('meta[name="theme-color"]:not([media])') ?? (() => {
    const m = document.createElement('meta');
    m.name = 'theme-color';
    document.head.appendChild(m);
    return m;
  })();
  meta.setAttribute('content', dark ? '#0f1115' : '#4f46e5');
}

mq?.addEventListener('change', () => current === 'SYSTEM' && paint());

export function applyTheme(t: Theme) {
  current = t;
  try {
    localStorage.setItem('taskos.theme', t);
  } catch {
    writeLocal('taskos.theme', t);
  }
  paint();
}
